const loading_messages = {
  book: {
    messages: [
      "<strong>Stiamo completando la tua prenotazione.</strong><br />&#128400;&nbsp; Richiesta inviata! Stiamo verificando i dettagli del viaggio.",
      "<strong>Stiamo completando la tua prenotazione.</strong><br />&#128588;&nbsp; A volte la conferma può richiedere fino a 30-60 secondi, in base al partner e ai servizi.",
      "<strong>Stiamo completando la tua prenotazione.</strong><br />&#9757;&#65039;&nbsp; Per evitare imprevisti non aggiornare la pagina e non tornare indietro.",
      "<strong>Stiamo completando la tua prenotazione.</strong><br />&#129309;&nbsp; Grazie per la pazienza. Stiamo ancora completando la conferma.",
      "<strong>Stiamo completando la tua prenotazione.</strong><br />&#128522;&nbsp; La tua richiesta sta impiegando più del previsto, ma è quasi fatta! Grazie per la pazienza.",
    ],
    footer: "Non aggiornare la pagina.",
  },
  search_suggestions: {
    messages: [
      "<strong>Nessun volo disponibile per la data che hai cercato</strong><br />Stiamo cercando alternative su date e aeroporti vicini...",
      "<strong>Stiamo analizzando tariffe e disponibilità...</strong>",
      "<strong>Ci siamo quasi!</strong><br />A breve vedrai le migliori alternative disponibili.",
    ],
    footer: "",
  },
}

export default loading_messages
